import React from 'react';

import {
  List,
} from '@mui/material';

import type { AttendContactLateJson } from '@/types/domain/attendContact/entities/attendContactLateEntity';

import CustomListItem from '@/components/CustomListItem';
import { ChildId } from '@/domain/attendContact/service/entity/valueObjects/childId';
import { LateDateTime } from '@/domain/attendContact/service/entity/valueObjects/lateDateTime';
import { Memo } from '@/domain/attendContact/service/entity/valueObjects/memo';
import { toStringDateDisplay, toStringTimeDisplay } from '@/utils/date';

const LateInfo: React.FC<{
  /** データ */
  data: AttendContactLateJson,
}> = ({ data }) => {
  const {
    childId,
    lateDateTime,
    memo,
  } = data.data;
  return (
    <>
      <List>
        <CustomListItem
          name={ChildId.label}
          content={childId}
        />
        <CustomListItem
          name={LateDateTime.labelDate}
          content={toStringDateDisplay(new Date(lateDateTime))}
        />
        <CustomListItem
          name={LateDateTime.labelTime}
          content={toStringTimeDisplay(new Date(lateDateTime))}
        />
      </List>
      <p style={{ marginLeft: '12px', color: '#666' }}>{Memo.label}</p>
      <p style={{ marginLeft: '24px' }}>{memo}</p>
    </>
  );
};

export default LateInfo;
